// Enhanced SelficAI Business Page
import React, { useEffect, useState } from 'react';
import home_wf from '../../assets/images/home_wf.jpg';
import { Activity, BrainCircuit, Briefcase, Cpu, MessagesSquare, Rocket, ShieldCheck, ShieldCheckIcon, Sparkles, Workflow } from 'lucide-react';
import {
    Brain,
    Shield,
    Zap,
    Settings,
    GitBranch,
    Database,
    MessageSquare,
    Upload,
    ArrowRight,
    Play,
    Bot,
    Lock,
    Code,
    Globe
} from 'lucide-react';
import SelficEnterpriseHero from './home2';
import homeAgentSimulation from './home2AgentSimulation';
import HomeAgentSimulation from './home2AgentSimulation';
import Navbar from '../home/Navbar';
import Footer from '../home/Footer';
import FeaturesSection from '../home/components/FeaturesSection';
import Home2FeaturesSection from './home2features';

const Home2Body = () => {
    const llms = ['ChatGPT', 'Claude', 'DeepSeek', 'LLaMA', 'Gemini'];
    const [text, setText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [i, setI] = useState(0);
    const [j, setJ] = useState(0);
    const speed = 120;

    useEffect(() => {
        const current = llms[i];
        const timeout = setTimeout(() => {
            if (!isDeleting) {
                setText(current.substring(0, j + 1));
                setJ(j + 1);
                if (j + 1 === current.length) setIsDeleting(true);
            } else {
                setText(current.substring(0, j - 1));
                setJ(j - 1);
                if (j - 1 === 0) {
                    setIsDeleting(false);
                    setI((i + 1) % llms.length);
                }
            }
        }, isDeleting ? speed / 2 : speed);
        return () => clearTimeout(timeout);
    }, [j, i, isDeleting]);

    const features = [
        { title: 'Multi-LLM Intelligence', desc: 'Dynamically switch between top LLMs like ChatGPT, Claude, and LLaMA.', icon: <path d="M9 17v-2a4 4 0 014-4h6" /> },
        { title: 'Vectorized Memory', desc: 'Scoped vector search for hyper-personalized agent recall.', icon: <path d="M12 6v6h4m2 4H6a2 2 0 01-2-2V6" /> },
        { title: 'Sidebar Copilot', desc: 'AI assistant that guides you live while working.', icon: <path d="M5 13l4 4L19 7" /> },
        { title: 'Triggers & Schedules', desc: 'Event-driven and time-based automation with one click.', icon: <path d="M12 8v4l3 3" /> },
        { title: 'Simulation Console', desc: 'Run what-if simulations to see risk, cost, outcomes.', icon: <path d="M11.25 6.75v10.5" /> },
        { title: 'Enterprise Security', desc: 'SSO, RBAC, tenant boundaries — secure from day one.', icon: <path d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75" /> },
    ];

    const agentStudioFeatures = [
        { title: 'Visual Agent Builder', desc: 'Create agents with inputs, outputs, prompts, and behavior via a modern UI.' },
        { title: 'Modular Runtime Inputs', desc: 'Accept user input, form data, or system context to drive decisions.' },
        { title: 'LLM + Logic + Memory', desc: 'Combine GPT-like models with structured rules and scoped memory.' },
    ];

    return (
        <>
            <Navbar />
            <main className="home2-page bg-black text-white font-sans">
                {/* Hero */}
                <section>
                    <SelficEnterpriseHero></SelficEnterpriseHero>

                </section> 
                {/* Agent Studio Highlights */}
                <section>
                    <HomeAgentSimulation></HomeAgentSimulation>
                </section>


                {/* Features Grid */}
                <section>
                    <Home2FeaturesSection></Home2FeaturesSection>
                </section>

                {/* Workflow Builder Section */}
                {/* <section>
        <EnterpriseWorkflowDemo></EnterpriseWorkflowDemo>
      </section> */}
            </main>
            <Footer />
        </>

    );
};

export default Home2Body;


